import {createStore, withProps} from '@ngneat/elf';
import {withEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';
import {GridSortItem} from '@mui/x-data-grid-pro';

import {User, UsersFilters} from '@store/settings/users/users.model';
import {TablePagination} from '@store/common/pagination.model';
import {TableConfig} from '@constants/table.constants';

export interface UsersState {
  filters: UsersFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
}

export const usersStore = createStore(
  {name: 'users'},
  withProps<UsersState>({
    filters: {search: '', tableFilters: UsersFilters.initTableFilters()},
    sort: {
      field: 'organisation.name',
      sort: 'asc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<User>(),
  withPagination(),
  withRequestsStatus(),
);
